//@ts-check
import request from '../request';
/**
 * Get the schema of a data file (csv, xml...)
 * @param {string} workspace
 * @param {string} path
 * @return {Promise<import("./types").ObjectSchema>}
 */

export var getSchema = function getSchema(workspace, path) {
  return request({
    url: '/backend/dataSchemas',
    query: {
      workspace: workspace,
      filePath: path
    }
  });
};
export default {
  getSchema: getSchema
};